import { createReducer } from '@reduxjs/toolkit'
import * as types from './types'

const initialState = {
  items: [],
  isFetching: false,
  isError: false,
  errorMessage: '',
  currentItem: {},
  pagination: {
    total: 1,
    pageCount: 1
  },
  deletedCoordinators: {
    items: [],
    pagination: {
      total: 1,
      pageCount: 1
    }
  }
}

const coordinatorsReducer = createReducer(initialState, {
  [types.GET_COORDINATOR]: (state, action) => ({
    ...state,
    currentItem: {},
    isFetching: true,
    isError: false,
    errorMessage: ''
  }),
  [types.GET_COORDINATOR_SUCCESSFUL]: (state, action) => ({
    ...state,
    items: action.payload.data,
    pagination: {
      total: action.payload.meta.total_count,
      pageCount: action.payload.meta.page_count
    },
    isFetching: false,
    isError: false,
    errorMessage: ''
  }),
  [types.GET_COORDINATOR_FAILURE]: (state, action) => ({
    ...state,
    isFetching: false,
    isError: true,
    errorMessage: action.payload
  }),
  [types.EDIT_COORDINATOR]: (state, action) => ({
    ...state,
    isFetching: true,
    currentItem: {},
    isError: false,
    errorMessage: ''
  }),
  [types.EDIT_COORDINATOR_SUCCESSFUL]: (state, action) => ({
    ...state,
    isFetching: false,
    isError: false,
    errorMessage: ''
  }),
  [types.EDIT_COORDINATOR_FAILURE]: (state, action) => ({
    ...state,
    isFetching: false,
    isError: true,
    errorMessage: action.payload
  }),
  [types.GET_COORDINATOR_BY_ID]: (state, action) => ({
    ...state,
    isFetching: true,
    currentItem: {},
    isError: false,
    errorMessage: ''
  }),
  [types.GET_COORDINATOR_BY_ID_SUCCESSFUL]: (state, action) => ({
    ...state,
    currentItem: action.payload,
    isFetching: false,
    isError: false,
    errorMessage: ''
  }),
  [types.GET_COORDINATOR_BY_ID_FAILURE]: (state, action) => ({
    ...state,
    currentItem: {},
    isFetching: false,
    isError: true,
    errorMessage: action.payload
  }),
  [types.GET_DELETED_COORDINATOR]: (state, action) => ({
    ...state,
    isFetching: true,
    isError: false,
    errorMessage: '',
    deletedCoordinators: {}
  }),
  [types.GET_DELETED_COORDINATOR_SUCCESSFUL]: (state, action) => ({
    ...state,
    isFetching: false,
    isError: false,
    deletedCoordinators: {
      items: [...action.payload.data],
      pagination: {
        total: action.payload.meta.total_count,
        pageCount: action.payload.meta.page_count
      }
    }
  }),
  [types.GET_DELETED_COORDINATOR_FAILURE]: (state, action) => ({
    ...state,
    isFetching: false,
    isError: true,
    errorMessage: ''
  })
})

export default coordinatorsReducer
